<template>
	<v-dialog
		flat
		v-model="$store.state.mainmenu.visible"
		max-width="600px"
	>
		<div
			class='techbox centered'
			style="position:relative;"
		>
			<div class="techbox-title">
				Main Menu
				<v-icon
					style="position:absolute;top:0;right:0;"
					@click="$store.state.mainmenu.visible=false"
				>mdi-close</v-icon>
			</div>
			<hr />

			<button
				class='tech-button menubtn'
				type="button"
				@click="setScreen('dashboard')"
			>
				Dashboard
			</button>
			<button
				class='tech-button menubtn'
				type="button"
				@click="setScreen('assettype')"
			>
				Asset Types
			</button>
			<button
				class='tech-button menubtn'
				type="button"
				@click="setScreen('explorer')"
			>
				Explorer
			</button>
			<!-- <button
				class='tech-button'
				style="width:50%;"
				type="button"
			>
				Profile
			</button> -->
			<button
				class='tech-button menubtn'
				type="button"
				@click="logOut"
			>
				Logout
			</button>

		</div>

	</v-dialog>
</template>
<script>
export default {
	methods: {
		setScreen(screen) {
			this.$store.commit("setScreen", { screen: screen });
			this.$store.state.mainmenu.visible = false;
		},
		openLocation(assettype) {
			this.$store.commit("setLocation", { assettype: assettype });
			this.$store.state.mainmenu.visible = false;
		},
		logOut() {
			this.$store.commit("hideMainMenu");
			// this.$store.commit("logOut", { pouch: this.$pouch });
			this.$store.dispatch("logOut", { pouch: this.$pouch });
		}
	}
};
</script>
<style>
.menubtn {
	width: 75%;
}
</style>